import React from 'react';
import PropTypes from 'prop-types';
import StatsCard from './stats-card';
import * as styles from './allhomes-agent-stats.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Stats = props => {
  var hasValue = function hasValue() {
    for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
      values[_key] = arguments[_key];
    }
    return values.some(val => val && val !== '0' && val !== '-');
  };
  if (props.sold || props.rented || props.soldDevelopments) {
    // search stats
    // display max of 2 cards with custom title (sourced from props.titleLeft and titleRight)
    return ___EmotionJSX("div", {
      css: styles.stats
    }, props.sold && ___EmotionJSX(StatsCard, {
      className: props.className,
      title: props.titleLeft,
      values: [{
        label: 'Sold',
        value: props.sold,
        bold: !props.sortAll
      }, {
        label: 'For sale',
        value: props.sale
      }, {
        label: 'Avg. days advertised',
        value: props.averageDays
      }],
      highlighted: !props.sortAll,
      bordered: !props.sortAll,
      fixedHeight: props.fixedHeight,
      key: "sold-1"
    }), props.rented && ___EmotionJSX(StatsCard, {
      className: props.className,
      title: props.titleLeft,
      values: [{
        label: 'Rented',
        value: props.rented,
        bold: !props.sortAll
      }, {
        label: 'For rent',
        value: props.rent
      }, {
        empty: true
      }],
      highlighted: !props.sortAll,
      bordered: !props.sortAll,
      fixedHeight: props.fixedHeight,
      key: "rented-1"
    }), props.soldDevelopments && ___EmotionJSX(StatsCard, {
      className: props.className,
      title: props.titleLeft,
      values: [{
        label: 'New homes sold',
        value: props.soldDevelopments,
        bold: !props.sortAll
      }, {
        label: 'Live projects',
        value: props.developments
      }, {
        empty: true
      }],
      highlighted: !props.sortAll,
      bordered: !props.sortAll,
      fixedHeight: props.fixedHeight,
      key: "sold-developments-1"
    }), props.sold && ___EmotionJSX(StatsCard, {
      className: props.className,
      title: props.titleRight,
      values: [{
        label: 'Sold',
        value: props.soldAll,
        bold: props.sortAll
      }, {
        label: 'For sale',
        value: props.saleAll
      }, {
        label: 'Avg. days advertised',
        value: props.averageDaysAll
      }],
      highlighted: props.sortAll,
      bordered: props.sortAll,
      fixedHeight: props.fixedHeight,
      key: "sold-2"
    }), props.rented && ___EmotionJSX(StatsCard, {
      className: props.className,
      title: props.titleRight,
      values: [{
        label: 'Rented',
        value: props.rentedAll,
        bold: props.sortAll
      }, {
        label: 'For rent',
        value: props.rentAll
      }, {
        empty: true
      }],
      highlighted: props.sortAll,
      bordered: props.sortAll,
      fixedHeight: props.fixedHeight,
      key: "rented-2"
    }), props.soldDevelopments && ___EmotionJSX(StatsCard, {
      className: props.className,
      title: props.titleRight,
      values: [{
        label: 'New homes sold',
        value: props.soldDevelopmentsAll,
        bold: props.sortAll
      }, {
        label: 'Live projects',
        value: props.developmentsAll
      }, {
        empty: true
      }],
      highlighted: props.sortAll,
      bordered: props.sortAll,
      fixedHeight: props.fixedHeight,
      key: "sold-development-2"
    }));
  }

  // profile stats
  // display max of 3 cards and do not display if no cards
  return ___EmotionJSX("div", {
    css: styles.stats
  }, hasValue(props.soldAll, props.saleAll, props.averageDaysAll, props.soldSecondary) && ___EmotionJSX(StatsCard, {
    className: props.className,
    title: "Sales",
    values: [{
      label: 'Sold',
      value: props.soldAll,
      bold: true
    }, {
      label: 'For sale',
      value: props.saleAll,
      bold: true
    }, {
      label: 'Avg. days advertised',
      value: props.averageDaysAll,
      bold: true
    }],
    secondaryType: "sold",
    secondaryValue: props.soldSecondary,
    highlighted: true,
    fixedHeight: props.fixedHeight,
    key: "sold-all-1"
  }), hasValue(props.rentedAll, props.rentAll, props.rentedSecondary) && ___EmotionJSX(StatsCard, {
    className: props.className,
    title: "Rentals",
    values: [{
      label: 'Rented',
      value: props.rentedAll,
      bold: true
    }, {
      label: 'For rent',
      value: props.rentAll,
      bold: true
    }, {
      empty: true
    }],
    secondaryType: "rented",
    secondaryValue: props.rentedSecondary,
    highlighted: true,
    fixedHeight: props.fixedHeight,
    key: "rented-all-1"
  }), hasValue(props.soldDevelopmentsAll, props.developmentsAll, props.soldDevelopmentsSecondary) && ___EmotionJSX(StatsCard, {
    className: props.className,
    title: "New Homes",
    values: [{
      label: 'New homes sold',
      value: props.soldDevelopmentsAll,
      bold: true
    }, {
      label: 'Live projects',
      value: props.developmentsAll,
      bold: true
    }, {
      empty: true
    }],
    secondaryType: "sold",
    secondaryValue: props.soldDevelopmentsSecondary,
    highlighted: true,
    fixedHeight: props.fixedHeight,
    key: "sold-development-all-1"
  }));
};
Stats.propTypes = {
  titleLeft: PropTypes.string,
  titleRight: PropTypes.string,
  soldAll: PropTypes.string,
  saleAll: PropTypes.string,
  averageDaysAll: PropTypes.string,
  rentedAll: PropTypes.string,
  rentAll: PropTypes.string,
  sold: PropTypes.string,
  sale: PropTypes.string,
  rented: PropTypes.string,
  rent: PropTypes.string,
  averageDays: PropTypes.string,
  sortAll: PropTypes.bool,
  soldSecondary: PropTypes.string,
  developmentsAll: PropTypes.string,
  soldDevelopmentsAll: PropTypes.string,
  soldDevelopments: PropTypes.string,
  soldDevelopmentsSecondary: PropTypes.string,
  rentedSecondary: PropTypes.string,
  developments: PropTypes.string,
  className: PropTypes.string,
  fixedHeight: PropTypes.bool
};
Stats.defaultProps = {
  titleLeft: '',
  titleRight: '',
  soldAll: undefined,
  saleAll: undefined,
  averageDaysAll: undefined,
  rentedAll: undefined,
  rentAll: undefined,
  sold: undefined,
  sale: undefined,
  rented: undefined,
  rent: undefined,
  averageDays: undefined,
  sortAll: false,
  soldSecondary: undefined,
  rentedSecondary: undefined,
  className: '',
  developments: undefined,
  developmentsAll: undefined,
  soldDevelopmentsAll: undefined,
  soldDevelopments: undefined,
  soldDevelopmentsSecondary: undefined,
  fixedHeight: false
};
export default Stats;